import React from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// Suppress Sentry errors for Reddit embed and other non-critical errors
if (typeof window !== "undefined") {
  const originalError = console.error;
  const originalWarn = console.warn;

  // Suppress errors from Reddit embeds and Sentry rate limiting
  console.error = (...args: any[]) => {
    const message = args.join(" ");
    if (
      message.includes("reddit") ||
      message.includes("Reddit") ||
      message.includes("sentry.io") ||
      message.includes("Sentry") ||
      message.includes("embed.redditmedia.com")
    ) {
      // Silently ignore these errors to prevent Sentry spam
      return;
    }
    originalError.apply(console, args);
  };

  // Suppress Sentry rate limit warnings
  console.warn = (...args: any[]) => {
    const message = args.join(" ");
    if (message.includes("sentry.io") || message.includes("Sentry")) {
      return;
    }
    originalWarn.apply(console, args);
  };

  // Catch unhandled promise rejections from Reddit embeds
  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason?.toString() || "";
    if (
      reason.includes("reddit") ||
      reason.includes("Reddit") ||
      reason.includes("embed.redditmedia.com")
    ) {
      event.preventDefault(); // Prevent Sentry from logging this
    }
  });

  // Catch unhandled errors from Reddit embeds
  window.addEventListener("error", (event) => {
    const message = event.message || "";
    if (
      message.includes("reddit") ||
      message.includes("Reddit") ||
      message.includes("embed.redditmedia.com")
    ) {
      event.preventDefault(); // Prevent Sentry from logging this
    }
  });
}

// Runtime health check for debugging
if (typeof window !== "undefined" && import.meta.env.PROD) {
  try {
    const reactVersion = React.version || "unknown";
    console.log("[HealthCheck] React version:", reactVersion);
  } catch (error) {
    console.log("[HealthCheck] Could not detect React version");
  }
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
